import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClienteEncabezado } from '@shared/models/cliente/ClienteEncabezado';
import { ClienteService } from '../cliente.service';

@Component({
  selector: 'app-clientes-lista',
  templateUrl: './clientes-lista.component.html',
  styleUrls: ['./clientes-lista.component.css']
})
export class ClientesListaComponent implements OnInit, OnChanges {
  @Output() clienteSeleccionado: EventEmitter<ClienteEncabezado> = new EventEmitter;
  @Output() clienteVerificar: EventEmitter<ClienteEncabezado[]> = new EventEmitter;
  @Output() nuevo: EventEmitter<boolean> = new EventEmitter;
  @Output() terminoCargaClientes: EventEmitter<boolean> = new EventEmitter;
  @Input() estados: any[];

  @Input()
  set clienteParaAgregar(cli: ClienteEncabezado){
    this.clientesFiltrados.push(cli);
  }

  @Input()
  set clienteBuscado(texto: string) {
    this.textoBuscador = texto;
    this.filtrarClientes(texto);
  }

  cargandoClientes: boolean;
  clientes: ClienteEncabezado[] = []; //luego cambiar al cliente del alta nuevo.
  clientesFiltrados: ClienteEncabezado[] = [];
  estadosClientes: any;
  textoBuscador: string = "";
  clientesCargados: boolean = false;

  constructor(private clienteService: ClienteService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.getClientes();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.estados && changes.estados.currentValue) {
      this.estadosClientes = changes.estados.currentValue;
      //Filtra clientes si ya se cargaron los clientes enviados desde backend
      if (this.clientesCargados){
        this.filtrarClientes();
      }
    }
  }

  getClientes() {
    this.cargandoClientes = true;
    this.spinner.show('spinnerGrafico');
    this.clienteService.getClientesEncabezado()
      .subscribe(result => {
        this.clientes = result;
        this.clientesFiltrados = result;
        this.spinner.hide('spinnerGrafico');
        this.cargandoClientes = false;
        this.clientesCargados = true;
        this.terminoCargaClientes.emit(true);
        // Filtrar clientes si ya hay estados disponibles
        if (this.estadosClientes) {
          this.filtrarClientes();
        }
      }
      )
  }

  mostrarDetalle(i: number) {
    this.clienteSeleccionado.emit(this.clientesFiltrados[i]);
    this.clienteVerificar.emit(this.clientes);
    this.nuevo.emit(false);
  }

  filtrarClientes(texto?: string) {
    this.clientesFiltrados = this.clientes.filter(a => {
      let agregar = true;
      if (texto) {
        agregar = a.razonSocial.toLowerCase().indexOf(texto.toLowerCase()) > -1; // Razón Social
        agregar = agregar || a.numeroDocumento.toLowerCase().indexOf(texto.toLowerCase()) > -1; // CUIT
        if(a.ctaSap != null){
          agregar = agregar || a.ctaSap.toLowerCase().indexOf(texto.toLowerCase()) > -1; // Nro Cuenta
        }
      }
      if (this.estadosClientes != null && this.estadosClientes.some(e => e.seleccionado)) {
          if (a.activo){
            agregar = agregar && this.estadosClientes.filter(c => c.valor === "Activo" && c.seleccionado).length > 0;
          }
          else {
            agregar = agregar && this.estadosClientes.filter(c => c.valor === "Inactivo" && c.seleccionado).length > 0;
          }
      }
      else {
        agregar = false;
      }
      return agregar;
    });
  }
}
